/* eslint-disable react/no-danger */
import axios from 'axios'
import * as React from 'react'

import * as styles from './svgSpriteWrapper.module.css'

interface IProps {
  spriteURL: string
  children: any
}

interface ISVGProps {
  iconId: string
  fallbackId: string
  backgroundColor?: string
}

interface ISVGSpriteProps extends React.SFC<IProps> {
  SVG: typeof SVG
}

const SVG: React.FC<ISVGProps> = ({ iconId, fallbackId, backgroundColor }) => (
  <svg className={styles.svgIcon}>
    <use fill={backgroundColor} xlinkHref={fallbackId} href={fallbackId} />
    <use fill={backgroundColor} xlinkHref={iconId} href={iconId} />
  </svg>
)

const SVGSpriteWrapper: ISVGSpriteProps = ({ spriteURL, children }) => {
  const [spriteValue, setSpriteValue] = React.useState('')

  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  React.useEffect(() => {
    axios
      .get(spriteURL, {
        cancelToken: source.token
      })
      .then(response => {
        setSpriteValue(response.data)
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          throw err
        }
      })

    return () => source.cancel('')
  }, [])

  return (
    <React.Fragment>
      <div
        className={styles.svgSprite}
        dangerouslySetInnerHTML={{ __html: spriteValue }}
      />

      {children}
    </React.Fragment>
  )
}

SVGSpriteWrapper.SVG = SVG
SVGSpriteWrapper.SVG.displayName = 'SVGSpriteWrapper.SVG'

export default SVGSpriteWrapper
